import { useInvoicesWithoutWcc } from 'features/wcc-bulk-create/invoices-without-wcc.hook';
import { HeadCellsCollection, GridLayout } from 'shared/ui/grid-layout';
import { InvoiceWccRow } from './invoice-wcc-row';
import { Box, Checkbox, TableCell, TableRow, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { WccBulkCreateFilter } from 'features/wcc-bulk-create/wcc-bulk-create-filter';
import { useActionCreators, useStateSelector } from 'shared/store';
import { wccBulkCreateActions } from './slice';
import PriceSpan from 'shared/ui/price-span';
import { ErrorBanner } from 'shared/ui/error-banner';
import { usePagingParams } from 'shared/hooks/paging-params';
import { ListTotalsCard } from 'shared/ui/totals-card';

export const BulkCreateList = () => {
  const [paging, setPaging] = usePagingParams();
  const [searchParams] = useSearchParams();
  const { collection, error, isLoading } = useInvoicesWithoutWcc(paging, searchParams.toString());

  const metaDiscountPriceTotal = collection.meta?.find((x) => x['discountPriceTotal'] !== undefined)?.['discountPriceTotal'];
  const totals = metaDiscountPriceTotal ?? collection.items.reduce((acc, wcc) => acc + wcc.totals.discountPriceTotal, 0);

  const checkedItems = useStateSelector((state) => state.wcc.bulkCreate.checkedItems);
  const { toggleChecked, checkAll, uncheckAll } = useActionCreators(wccBulkCreateActions);

  const handleToggleAll = (e: any, checked: boolean) => {
    if (checked) checkAll(collection.items.map((x) => x.id));
    else uncheckAll();
  };

  const isAllChecked = () => checkedItems.length !== collection.items.length;

  const handleCheckChange = (id: number, checked: boolean) => {
    toggleChecked({ id, checked });
  };

  if (error) {
    return <ErrorBanner errorMessage={error} />;
  }

  const columns: HeadCellsCollection = [
    {
      label: <Checkbox onChange={handleToggleAll} value={!isAllChecked()} indeterminate={isAllChecked() && checkedItems.length > 0} />,
      align: 'left',
      padding: 'checkbox'
    },
    'Счет',
    'ПП',
    'Дата окончания работ',
    'Наше юрлицо',
    'Клиент',
    'Менеджер',
    { label: 'Заявки', align: 'right' },
    { label: 'Сумма счета', align: 'right' },
    { label: 'Статус счета', align: 'right' }
  ];


  return (
    <>
      <Box my={1}>
        <WccBulkCreateFilter />
      </Box>

      <GridLayout
        tableOptions={{ component: 'div' }}
        columns={columns}
        items={collection.items}
        pagingData={paging}
        onChangePaging={setPaging}
        totalItemsCount={collection.totalItemsCount}
        isLoading={isLoading}
        noItemsText="Список счетов пуст"
        footer={() => <WccFooter totalSum={totals} />}
        renderCustomHeader={() => <ListTotalsCard meta={[{ title: 'Сумма', value: metaDiscountPriceTotal }]} />}
        itemRender={(invoice) => (
          <InvoiceWccRow
            key={invoice.id}
            invoice={invoice}
            checked={checkedItems.some((x) => x === invoice.id)}
            onCheckChange={(checked) => handleCheckChange(invoice.id, checked)}
          />
        )}
      />
    </>
  );
};

const WccFooter = ({ totalSum }: {totalSum: number}) => {
  return (
    <TableRow>
      <TableCell colSpan={8} align="right">
        <Typography>Итого:</Typography>
      </TableCell>
      <TableCell align="right">
        <PriceSpan price={totalSum} />
      </TableCell>
      <TableCell></TableCell>
    </TableRow>
  );
};